/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ who: NonNullable<unknown> }} Ui_Preview_BannerInputs */

const en_ui_preview_banner = /** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are previewing as ${i?.who}. Nothing can be changed.`)
};

/**
* | output |
* | --- |
* | "You are previewing as {who}. Nothing can be changed." |
*
* @param {Ui_Preview_BannerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ui_preview_banner = /** @type {((inputs: Ui_Preview_BannerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Preview_BannerInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ui_preview_banner(inputs)
});